import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportsComponent } from './reports.component';
import { ManageAutomationProcessReportComponent } from './manage-AutomationProcessReport/manage-AutomationProcessReport.component';
import { ManageFormUseReportComponent } from './manage-FormUseReports/manage-FormUseReports.component';
import { ManageProjectStatusReportComponent } from './manage-ProjectStatusReports/manage-ProjectStatusReports.component';
import { ManageProjectDataReportComponent } from './manage-ProjectDataReports/manage-ProjectDataReports.component';


const routes: Routes = [
  {
    path: '',
    component: ReportsComponent,
    children: [
      // {
      //   path:'',
      //   component: ManageFormUseReportComponent,
      // },  
      {
        path:'manageAutomationProcessReport',
        component: ManageAutomationProcessReportComponent
      },     
      {
        path:'manageFormUseReport',
        component: ManageFormUseReportComponent
      },    
      {
        path:'manageProjectStatusReport',
        component: ManageProjectStatusReportComponent
      }, 
      {
        path:'manageProjectDataReport',
        component: ManageProjectDataReportComponent
      }, 
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class reportRoutingModule { }
